import React, { useContext, useState } from "react";
import "../../styles/layout/HeaderNav.css";
import firstBankDefsultImg from "../../assets/favicon.png";
import { useLocation, useNavigate } from "react-router-dom";
import ActionContext from "../../context/ActionContext";
import { RouteLinks } from "../../routes/RouteLinks";
import { useOnClickOutside } from "../../utils/UseOnClickOutside";
import { lowerCaseWrap } from "../../helper";
import { FaBars } from "react-icons/fa";
// import defaultUnknown from "../../assets/default-img.jpeg"
import defaultUnknown from "../../assets/Unknown_person.jpeg";

interface MyComponentProps {
  theme: any;
  toggleTheme: (param: String) => void;
}

const linkList = [
  { name: "Overview", link: RouteLinks?.Overview },

  { name: "Transactions", link: RouteLinks.Transactions },

  {
    name: "Terminals",
    link: RouteLinks?.Physical_Terminal_list,
    relatedLinks: [
      RouteLinks?.Terminal_details,
      RouteLinks?.Request_Terminal,
      RouteLinks?.Terminal_Virtual_List,
      RouteLinks?.AllRequested_Terminal,
      RouteLinks?.Physical_Terminal_list,
      RouteLinks?.Request_Virtual_Terminal_display,
      RouteLinks?.Physical_Terminal,
      RouteLinks?.Terminals_Virtual,
      RouteLinks?.Request_Terminal,
    ],
  },

  { name: "Settings", link: RouteLinks.Settings_business_profile },
];

const lightIcon = (
  <svg
    className="img"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.18971 5.12352C5.29204 5.13079 5.3939 5.14364 5.49482 5.16204C6.09336 5.28906 6.52225 5.61819 6.69406 6.22236C6.75335 6.43009 6.76439 6.65189 6.79382 6.86785C6.81027 6.98665 6.87345 7.05763 6.97083 7.05352C7.0615 7.04984 7.11971 6.978 7.12771 6.85877C7.13355 6.77351 7.13572 6.68782 7.14502 6.60277C7.19414 6.16263 7.34973 5.77464 7.70526 5.48922C8.00821 5.24665 8.36093 5.14603 8.74156 5.12309C8.86274 5.11573 8.93263 5.05363 8.93501 4.95452C8.93761 4.85195 8.86339 4.78422 8.74026 4.77383C8.66193 4.76734 8.58316 4.76366 8.50591 4.75025C8.04824 4.67126 7.66588 4.46894 7.41032 4.06645C7.22314 3.77194 7.15433 3.44346 7.14762 3.09983C7.14546 2.98579 7.12057 2.88971 7.00415 2.84167H6.92192C6.83537 2.89123 6.7936 2.96307 6.79057 3.06629C6.78721 3.18954 6.77564 3.31244 6.75595 3.43415C6.68216 3.89139 6.47183 4.26531 6.07107 4.51611C5.80426 4.68252 5.50975 4.76172 5.19664 4.77578C5.07416 4.78141 4.99474 4.8539 4.99712 4.95279C4.9995 5.05168 5.07286 5.11205 5.18971 5.12352Z"
      fill="white"
    />
    <path
      d="M13.5512 7.68612C13.5152 7.67643 13.4785 7.66991 13.4413 7.66664C13.2485 7.63981 13.0518 7.62726 12.8633 7.58506C11.5899 7.30094 10.8031 6.44987 10.6157 5.15391C10.5834 4.93102 10.5772 4.70446 10.5596 4.47941C10.5503 4.36278 10.4832 4.29094 10.3833 4.29289C10.2798 4.29505 10.221 4.37382 10.2091 4.5069C10.1842 4.78561 10.1727 5.06757 10.1214 5.34173C10.0052 5.96408 9.73064 6.50873 9.24441 6.9268C8.68028 7.41217 8.01098 7.63051 7.27525 7.66751C7.13373 7.67465 7.06015 7.73589 7.05885 7.8482C7.05756 7.9605 7.13135 8.02326 7.27049 8.03429C7.42694 8.04663 7.5849 8.05442 7.73941 8.08082C8.30657 8.17841 8.82136 8.39523 9.25544 8.78128C9.8278 9.29153 10.0842 9.95606 10.1669 10.6998C10.1872 10.8831 10.1885 11.0677 10.2048 11.2525C10.2128 11.3475 10.2746 11.4018 10.3686 11.4039C10.4625 11.4061 10.522 11.3537 10.5395 11.26C10.545 11.2263 10.5486 11.1923 10.5503 11.1581C10.5661 10.9538 10.5702 10.747 10.5992 10.5451C10.6858 9.94265 10.9002 9.39431 11.3244 8.94573C11.8234 8.41839 12.4539 8.15526 13.162 8.05853C13.2801 8.04208 13.4 8.04403 13.5194 8.02845C13.606 8.01677 13.675 7.96721 13.6822 7.87157C13.6893 7.77592 13.6408 7.71447 13.5512 7.68612Z"
      fill="white"
    />
    <path
      d="M8.18067 10.6035C8.05819 10.5913 7.93485 10.5844 7.81281 10.5643C6.9652 10.4234 6.34957 9.89565 6.16304 9.04956C6.11392 8.82754 6.10872 8.59513 6.08254 8.36836C6.07064 8.26535 6.01135 8.20455 5.92198 8.2C5.82698 8.19503 5.76012 8.2528 5.74151 8.3584C5.73743 8.38891 5.73497 8.4196 5.73415 8.45037C5.72571 8.56982 5.72355 8.68991 5.70775 8.8085C5.63699 9.34363 5.42644 9.80779 4.99496 10.1501C4.61368 10.4531 4.16748 10.5773 3.6886 10.6024C3.56072 10.6091 3.48801 10.6688 3.4852 10.7709C3.48217 10.877 3.55747 10.943 3.6899 10.9525C3.76824 10.9583 3.84657 10.9653 3.92469 10.9741C4.84608 11.0804 5.4998 11.6841 5.66815 12.5956C5.70407 12.7903 5.70818 12.9896 5.72809 13.1867C5.73783 13.2822 5.80578 13.354 5.89233 13.3527C5.9856 13.3514 6.04597 13.3014 6.06545 13.2086C6.07061 13.1783 6.07394 13.1477 6.0754 13.1171C6.08968 12.9572 6.09206 12.7951 6.11976 12.6375C6.24657 11.9137 6.6298 11.3887 7.32528 11.1124C7.57116 11.0172 7.83108 10.9631 8.09455 10.9525C8.24343 10.9449 8.31721 10.8785 8.31548 10.7279C8.31267 10.6654 8.27112 10.6126 8.18067 10.6035Z"
      fill="white"
    />
    <path
      d="M5.18971 5.12352C5.29204 5.13079 5.3939 5.14364 5.49482 5.16204C6.09336 5.28906 6.52225 5.61819 6.69406 6.22236C6.75335 6.43009 6.76439 6.65189 6.79382 6.86785C6.81027 6.98665 6.87345 7.05763 6.97083 7.05352C7.0615 7.04984 7.11971 6.978 7.12771 6.85877C7.13355 6.77351 7.13572 6.68782 7.14502 6.60277C7.19414 6.16263 7.34973 5.77464 7.70526 5.48922C8.00821 5.24665 8.36093 5.14603 8.74156 5.12309C8.86274 5.11573 8.93263 5.05363 8.93501 4.95452C8.93761 4.85195 8.86339 4.78422 8.74026 4.77383C8.66193 4.76734 8.58316 4.76366 8.50591 4.75025C8.04824 4.67126 7.66588 4.46894 7.41032 4.06645C7.22314 3.77194 7.15433 3.44346 7.14762 3.09983C7.14546 2.98579 7.12057 2.88971 7.00415 2.84167H6.92192C6.83537 2.89123 6.7936 2.96307 6.79057 3.06629C6.78721 3.18954 6.77564 3.31244 6.75595 3.43415C6.68216 3.89139 6.47183 4.26531 6.07107 4.51611C5.80426 4.68252 5.50975 4.76172 5.19664 4.77578C5.07416 4.78141 4.99474 4.8539 4.99712 4.95279C4.9995 5.05168 5.07286 5.11205 5.18971 5.12352Z"
      fill="white"
    />
    <path
      d="M13.5512 7.68612C13.5152 7.67643 13.4785 7.66991 13.4413 7.66664C13.2485 7.63981 13.0518 7.62726 12.8633 7.58506C11.5899 7.30094 10.8031 6.44987 10.6157 5.15391C10.5834 4.93102 10.5772 4.70446 10.5596 4.47941C10.5503 4.36278 10.4832 4.29094 10.3833 4.29289C10.2798 4.29505 10.221 4.37382 10.2091 4.5069C10.1842 4.78561 10.1727 5.06757 10.1214 5.34173C10.0052 5.96408 9.73064 6.50873 9.24441 6.9268C8.68028 7.41217 8.01098 7.63051 7.27525 7.66751C7.13373 7.67465 7.06015 7.73589 7.05885 7.8482C7.05756 7.9605 7.13135 8.02326 7.27049 8.03429C7.42694 8.04663 7.5849 8.05442 7.73941 8.08082C8.30657 8.17841 8.82136 8.39523 9.25544 8.78128C9.8278 9.29153 10.0842 9.95606 10.1669 10.6998C10.1872 10.8831 10.1885 11.0677 10.2048 11.2525C10.2128 11.3475 10.2746 11.4018 10.3686 11.4039C10.4625 11.4061 10.522 11.3537 10.5395 11.26C10.545 11.2263 10.5486 11.1923 10.5503 11.1581C10.5661 10.9538 10.5702 10.747 10.5992 10.5451C10.6858 9.94265 10.9002 9.39431 11.3244 8.94573C11.8234 8.41839 12.4539 8.15526 13.162 8.05853C13.2801 8.04208 13.4 8.04403 13.5194 8.02845C13.606 8.01677 13.675 7.96721 13.6822 7.87157C13.6893 7.77592 13.6408 7.71447 13.5512 7.68612Z"
      fill="white"
    />
    <path
      d="M8.18067 10.6035C8.05819 10.5913 7.93485 10.5844 7.81281 10.5643C6.9652 10.4234 6.34957 9.89565 6.16304 9.04956C6.11392 8.82754 6.10872 8.59513 6.08254 8.36836C6.07064 8.26535 6.01135 8.20455 5.92198 8.2C5.82698 8.19503 5.76012 8.2528 5.74151 8.3584C5.73743 8.38891 5.73497 8.4196 5.73415 8.45037C5.72571 8.56982 5.72355 8.68991 5.70775 8.8085C5.63699 9.34363 5.42644 9.80779 4.99496 10.1501C4.61368 10.4531 4.16748 10.5773 3.6886 10.6024C3.56072 10.6091 3.48801 10.6688 3.4852 10.7709C3.48217 10.877 3.55747 10.943 3.6899 10.9525C3.76824 10.9583 3.84657 10.9653 3.92469 10.9741C4.84608 11.0804 5.4998 11.6841 5.66815 12.5956C5.70407 12.7903 5.70818 12.9896 5.72809 13.1867C5.73783 13.2822 5.80578 13.354 5.89233 13.3527C5.9856 13.3514 6.04597 13.3014 6.06545 13.2086C6.07061 13.1783 6.07394 13.1477 6.0754 13.1171C6.08968 12.9572 6.09206 12.7951 6.11976 12.6375C6.24657 11.9137 6.6298 11.3887 7.32528 11.1124C7.57116 11.0172 7.83108 10.9631 8.09455 10.9525C8.24343 10.9449 8.31721 10.8785 8.31548 10.7279C8.31267 10.6654 8.27112 10.6126 8.18067 10.6035Z"
      fill="white"
    />
  </svg>
);

const darkIcon = (
  <svg
    className="img"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.76797 5.76867C9.85507 5.77468 9.94177 5.78559 10.0276 5.80135C10.5385 5.90954 10.9047 6.19085 11.0516 6.70565C11.102 6.88309 11.1115 7.07243 11.1366 7.25658C11.1505 7.35828 11.2046 7.41866 11.2881 7.41519C11.3656 7.41216 11.4151 7.35028 11.4221 7.24944C11.427 7.17673 11.429 7.10359 11.437 7.0311C11.4788 6.65523 11.6116 6.32393 11.9152 6.08028C12.1729 5.87319 12.475 5.78728 12.7998 5.76781C12.9033 5.76153 12.963 5.70852 12.9652 5.62369C12.9673 5.53886 12.9039 5.47849 12.7983 5.46962C12.7317 5.46399 12.6642 5.46075 12.5984 5.4495C12.2078 5.38176 11.8815 5.20865 11.6625 4.86567C11.5028 4.61422 11.4441 4.334 11.4383 4.04035C11.4364 3.94319 11.4154 3.86097 11.3158 3.82007H11.2457C11.2109 3.83823 11.1819 3.86585 11.162 3.89977C11.1422 3.93369 11.1324 3.97252 11.1336 4.01179C11.1306 4.11677 11.1207 4.22144 11.104 4.32513C11.0408 4.71463 10.8614 5.03467 10.5197 5.24804C10.2919 5.3902 10.0406 5.45772 9.77317 5.47005C9.66865 5.47481 9.60005 5.5367 9.60287 5.62153C9.60568 5.70635 9.66822 5.75872 9.76797 5.76867Z"
      fill="#C8C9C7"
    />
    <path
      d="M14.1184 9.24556C13.5433 11.3084 11.6276 12.8123 9.36865 12.7606C6.73278 12.6992 4.62405 10.4952 4.67295 7.85914C4.68774 7.06439 4.89935 6.2857 5.28884 5.59278C5.67834 4.89986 6.23356 4.31432 6.90481 3.88857C6.9368 3.86832 6.97382 3.85744 7.01168 3.85718C7.04953 3.85692 7.0867 3.86729 7.11896 3.8871C7.15122 3.90692 7.17727 3.93539 7.19415 3.96927C7.21104 4.00315 7.21808 4.04109 7.21447 4.07878C7.19889 4.2366 7.19103 4.39651 7.19088 4.55852C7.19088 7.21602 9.34484 9.3702 12.0019 9.3702C12.6354 9.37084 13.2628 9.24611 13.8479 9.0032C13.883 8.98905 13.9213 8.98501 13.9586 8.99154C13.9958 8.99807 14.0305 9.01491 14.0587 9.04014C14.0868 9.06537 14.1074 9.09799 14.1179 9.1343C14.1285 9.17061 14.1287 9.20915 14.1184 9.24556Z"
      fill="#B9DEFE"
    />
  </svg>
);

const themeList = [
  { name: "light", icon: lightIcon },
  { name: "dark", icon: darkIcon },
];

const HeaderNav: React.FC<MyComponentProps> = ({ theme, toggleTheme }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const actionCtx = useContext(ActionContext);
  const [profileDrop, setProfileDrop] = useState(false);

  const testingRef = useOnClickOutside(() => {
    setProfileDrop(false);
  });

  const logoutIcon = (
    <svg
      className="img"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.059 18.3001C10.059 18.8571 10.2821 19.3912 10.6792 19.7851C11.0764 20.1789 11.615 20.4001 12.1766 20.4001L19.5884 20.4001C20.15 20.4001 20.6887 20.1789 21.0858 19.7851C21.4829 19.3912 21.7061 18.8571 21.7061 18.3001L21.7061 5.70015C21.7061 5.14319 21.4829 4.60905 21.0858 4.21522C20.6887 3.8214 20.15 3.60015 19.5884 3.60015L12.1766 3.60015C11.615 3.60015 11.0764 3.8214 10.6792 4.21522C10.2821 4.60905 10.059 5.14319 10.059 5.70015L10.059 11.0001L6.42858 11.0001L7.88062 9.56021C8.27277 9.17132 8.27542 8.53816 7.88653 8.146C7.49765 7.75385 6.86449 7.7512 6.47233 8.14009L3.29586 11.2901C3.10651 11.4779 3.00001 11.7335 3.00001 12.0001C3.00001 12.2668 3.10651 12.5224 3.29586 12.7102L6.47233 15.8602C6.86449 16.2491 7.49765 16.2464 7.88653 15.8543C8.27542 15.4621 8.27277 14.829 7.88062 14.4401L6.42858 13.0001L10.059 13.0001L10.059 18.3001ZM10.0615 13.0001L16.7061 13.0002C17.2583 13.0002 17.7061 12.5525 17.7061 12.0002C17.7061 11.448 17.2583 11.0002 16.7061 11.0002L10.0752 11.0002L10.0752 13.0001L10.0615 13.0001Z"
        fill="#FF0F00"
      />
    </svg>
  );

  return (
    <div
      // onClick={() => {
      //   console.log(actionCtx?.configDetails);
      // }}
      className="header-nav-index-wrap "
    >
      {/* mobile l=slide bar toggle start */}
      <div
        onClick={() => {
          actionCtx.setSideNavMobile(true);
        }}
        className="mobile-slide-bar-toggle-box"
      >
        <FaBars className="icon" />
      </div>
      {/* mobile l=slide bar toggle end */}
      {/* sideNav mobile wrap box start */}
      {
        <div
          className={`side-nav-mobile-wrap-box ${
            actionCtx?.isSideNavMobile && "translateX"
          }`}
        >
          <div
            onClick={() => {
              actionCtx.setSideNavMobile(false);
            }}
            className="inner-wrap"
          ></div>
          <div
            className={`side-list-box ${
              actionCtx?.isSideNavMobile && "translateX"
            }`}
          >
            {/* logo text box start */}
            <div className="logo-text-box">
              <div className="logo-box">
                <figure className="img-box">
                  <img
                    src={
                      actionCtx?.configDetails?.partnerInfo?.logo_url ||
                      firstBankDefsultImg
                    }
                    alt=""
                    className="img"
                  />
                </figure>
              </div>
              <div className="logo-text">
                <p className="text">
                  {lowerCaseWrap(
                    actionCtx?.configDetails?.partnerInfo?.app_name
                  ) || "---"}
                </p>
              </div>
            </div>
            {/* logo text box end */}
            {/* link list box start */}
            <div className="link-list-box">
              {linkList?.map((chi, idx) => {
                const { name, link } = chi || {};
                return (
                  <div
                    key={idx}
                    onClick={() => {
                      if (location?.pathname !== link) {
                        navigate(link);
                        actionCtx.setSideNavMobile(false);
                      }
                    }}
                    className={`link-item ${
                      location?.pathname?.includes(link) && "link-item-active"
                    }`}
                  >
                    <span className="link">{name}</span>
                  </div>
                );
              })}
            </div>
            {/* link list box end */}
            {/* theme box start */}
            <div className="theme-wrap-box">
              {themeList?.map((chi, idx) => {
                const { name, icon } = chi || {};
                return (
                  <div
                    key={idx}
                    onClick={() => {
                      if (theme !== name) {
                        toggleTheme(name);
                        actionCtx?.setThemeChnage(!actionCtx?.themeChange);
                      }
                    }}
                    className={`theme-nav-box  ${
                      theme === name && "theme-nav-box-active"
                    }`}
                  >
                    <figure className="img-box">{icon}</figure>
                  </div>
                );
              })}
            </div>
            {/* theme box end */}
          </div>
        </div>
      }
      {/* sideNav mobile wrap box end */}
      {/* logo text box start */}
      <div className="logo-text-box">
        <div className="logo-box">
          <figure className="img-box">
            <img
              src={
                actionCtx?.configDetails?.partnerInfo?.logo_url ||
                firstBankDefsultImg
              }
              alt=""
              className="img"
            />
          </figure>
        </div>
        <div className="logo-text">
          <p className="text">
            {lowerCaseWrap(actionCtx?.configDetails?.partnerInfo?.app_name) ||
              "---"}
          </p>
        </div>
      </div>
      {/* logo text box end */}
      {/* link list box start */}
      <div className="link-list-box">
        {linkList?.map((chi, idx) => {
          const { name, link } = chi || {};
          return (
            <div
              key={idx}
              onClick={() => {
                if (location?.pathname !== link) {
                  navigate(link);
                }
              }}
              className={`link-item ${
                location?.pathname?.includes(link) && "link-item-active"
              } 
                   ${
                     chi?.relatedLinks?.includes(location?.pathname) &&
                     "link-item-active"
                   }`}
            >
              <span className="link">{name}</span>
            </div>
          );
        })}
      </div>
      {/* link list box end */}
      {/* theme box start */}
      <div className="theme-wrap-box">
        {themeList?.map((chi, idx) => {
          const { name, icon } = chi || {};
          return (
            <div
              key={idx}
              onClick={() => {
                if (theme !== name) {
                  toggleTheme(name);
                  actionCtx?.setThemeChnage(!actionCtx?.themeChange);
                }
              }}
              className={`theme-nav-box  ${
                theme === name && "theme-nav-box-active"
              }`}
            >
              <figure className="img-box">{icon}</figure>
            </div>
          );
        })}
      </div>
      {/* theme box end */}
      {/* profile  box start  */}
      <div ref={testingRef} className="profile-box-wrap-index">
        <div
          className="profile-box-img"
          onClick={() => {
            setProfileDrop(!profileDrop);
          }}
        >
          <figure className="img-box">
            <img src={defaultUnknown} className="img" alt="" />
          </figure>
        </div>
        {/* profile drop box start */}
        {profileDrop && (
          <div className="profile-drop-box card-bg border-theme">
            <div
              onClick={() => {
                actionCtx?.setLogoutModal(true);
              }}
              className="icon-text-box"
            >
              {" "}
              <div className="img-wrap-box">
                <figure className="img-box">{logoutIcon}</figure>
              </div>
              <p className="text red">Logout</p>
            </div>
          </div>
        )}
        {/* profile drop box end */}
      </div>
      {/* profile  box end  */}
    </div>
  );
};

export default HeaderNav;
